module.exports = __webpack_public_path__ + "static/img/iphone_room5.d68957b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room5.png
// module id = rIIY
// module chunks = 0